import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Banner from '../../../components/Banner';
import SFButton from '../../../components/SFButton';
import submitted_icon from '../../../images/jobicons/Pink Application Submitted Icon.svg';
export default function Submitted({ item }) {
  let navigate = useNavigate();
  const [bannerWarningOpen, setBannerWarningOpen] = useState(true);
  const completeapp = () => {
    navigate(`/progress/`);
  };
  return (
    <>
      <div className="flex flex-col col-span-full xl:col-span-8 bg-white my-3 lgg:my-0 lgg:mb-5">
        <Banner type="submitted" open={bannerWarningOpen} setOpen={setBannerWarningOpen}>
          You have submitted an Application for <span className="font-semibold">Provider SE Columbus</span>.{' '}
          <a href="#" className="font-semibold text-pink-500">
            View Application
          </a>
        </Banner>
      </div>
      <div className="p-6 shadow-lg rounded-sm">
        <header className="pb-4 relative">
          <div className="flex flex-col lgg:flex-row">
            <div className="w-full mb-2">
              <h1 className="text-base text-portal-600 font-semibold my-1">{item && item.name}</h1>
              <div className="text-sm text-slate-500 my-1">
                <span className="text-gray-500">Posted on:</span> <span className="text-black">{item && item.posted_date}</span>
              </div>
            </div>
            <div className="w-full">
              <div className="flex flex-row justify-end bg-portal-100 p-2 px-2 lgg:px-8 lgg:py-2 rounded-lg">
                <div className="w-3/4">
                  <div className="">
                    <div className="text-sm text-slate-500 my-1">
                      <span className=" text-gray-500">Applied On:</span>{' '}
                      <span className=" text-black">{item && item.start_date}</span>
                    </div>
                    <div className="text-sm text-slate-500 my-1">
                      <span className="text-gray-500">Application Status:</span>{' '}
                      <span className="text-blue-900 font-semibold capitalize">{item && item.status}</span>
                    </div>
                  </div>
                </div>
                <div className="w-1/4 text-right justify-end items-end">
                  <img className="h-14 text-right float-right" src={submitted_icon} alt="started icon" />
                </div>
              </div>
            </div>
          </div>
        </header>
        <hr className="mb-6 border-t border-slate-200" />
        <div className="mb-6">
          <h2 className="text-sm leading-snug text-portal-300 font-semibold my-3">Job Description</h2>
          <div className="space-y-6 text-gray-800  text-sm lgg:text-base">
            <p>{item && item.description.replace(/\n/g, '<br>')}</p>
          </div>
        </div>
        <div>
          <div className="flex items-center">
            <span className="text-sm leading-snug text-portal-300 font-semibold my-1">Region:</span>
            <span className="text-sm font-medium whitespace-nowrap text-slate-500 ml-2">{item && item.region}</span>
            <svg className="ml-2 w-4 h-4 fill-current shrink-0 text-portal-300" viewBox="0 0 16 16">
              <path d="M8 8.992a2 2 0 1 1-.002-3.998A2 2 0 0 1 8 8.992Zm-.7 6.694c-.1-.1-4.2-3.696-4.2-3.796C1.7 10.69 1 8.892 1 6.994 1 3.097 4.1 0 8 0s7 3.097 7 6.994c0 1.898-.7 3.697-2.1 4.996-.1.1-4.1 3.696-4.2 3.796-.4.3-1 .3-1.4-.1Zm-2.7-4.995L8 13.688l3.4-2.997c1-1 1.6-2.198 1.6-3.597 0-2.798-2.2-4.996-5-4.996S3 4.196 3 6.994c0 1.399.6 2.698 1.6 3.697 0-.1 0-.1 0 0Z" />
            </svg>
          </div>
        </div>

        <div className="mb-1">
          <h2 className="text-sm leading-snug text-portal-300 font-semibold my-3">Requirements:</h2>
          {/* Tags */}
          <div className="mb-1">
            <div className="flex flex-wrap items-center">
              {item &&
                item.requirements.map((item, index) => (
                  <div className="m-1" key={index}>
                    <a
                      className="text-xs inline-flex font-medium bg-portalother-300 text-black rounded-full text-center px-3.5 py-1.5"
                      href="#0">
                      {item}
                      <svg
                        className="ml-2 mt-1 w-3 h-3 text-black group-hover:fill-slate-600 pointer-events-none"
                        viewBox="0 0 16 16"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="m7.95 6.536 4.242-4.243a1 1 0 1 1 1.415 1.414L9.364 7.95l4.243 4.242a1 1 0 1 1-1.415 1.415L7.95 9.364l-4.243 4.243a1 1 0 0 1-1.414-1.415L6.536 7.95 2.293 3.707a1 1 0 0 1 1.414-1.414L7.95 6.536Z" />
                      </svg>
                    </a>
                  </div>
                ))}
            </div>
          </div>
        </div>
        <div className="flex my-4">
          <div className="w-full md:w-1/3 pr-3">
            <SFButton
              onClick={(e) => {
                e.stopPropagation();
                completeapp();
              }}
              variant="success"
              text="View Application"
            />
          </div>
        </div>
      </div>
    </>
  );
}
